import { render, staticRenderFns } from "./TarafCard.vue?vue&type=template&id=29d1e96d&scoped=true"
import script from "./TarafCard.vue?vue&type=script&lang=ts"
export * from "./TarafCard.vue?vue&type=script&lang=ts"
import style0 from "./TarafCard.vue?vue&type=style&index=0&id=29d1e96d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d1e96d",
  null
  
)

export default component.exports